export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14046.d1b1950d.jpg";